import { createSlice } from "@reduxjs/toolkit";
import useApi from "../api";
import { makeCategoryEnumFriendly } from "../enum";
import { handleRetriveError } from "../utils";

interface CategoriesState {
    results: any[];
}

const initialState: CategoriesState = {
    results: [],
};

const categoriesSlice = createSlice({
    name: "categories",
    initialState,
    reducers: {
        setCategories(state, action) {
            state.results = action.payload;
        },
    },
});

// Export the action so it can be dispatched
export const { setCategories } = categoriesSlice.actions;

export const fetchRecursiveCategories = () => async (dispatch: any) => {
    const api = useApi();
    try {
        const response = await api.getRecursiveCategories() as any;
        const category = makeCategoryEnumFriendly(response);
        dispatch(setCategories(category));
    } catch (error) {
        handleRetriveError(error);
    }
};

export default categoriesSlice.reducer;
